import { Box, Grid, Typography } from "@mui/material";

const commonStyles = {
  border: "1px solid #e0e0e0",
  p: 2,
  borderRadius: "8px",
  overflowY: "auto",
  fontFamily: "'Cardiuma-M', sans-serif",
  boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
  backgroundColor: "#0B1420",
  "& .ql-size-small": { fontSize: "12px" },
  "& .ql-size-normal": { fontSize: "16px" },
  "& .ql-size-large": { fontSize: "20px" },
  "& .ql-indent-1": { paddingLeft: "20px" },
  "& .ql-indent-2": { paddingLeft: "40px" },
  "& .ql-indent-3": { paddingLeft: "60px" },
  "& .social-media-icon": { marginRight: "4px" },
};

const DevicePreview = ({ value }) => {
  const devicePreviews = [
    { title: "Mobile Preview", width: "320px", height: "568px", icon: "📱" },
    { title: "Tablet Preview", width: "768px", height: "1024px", icon: "📄" },
    { title: "Laptop Preview", width: "1024px", height: "768px", icon: "💻" },
  ];

  return (
    <Grid container spacing={3} sx={{ backgroundColor: "#0B1420" }}>
      <Grid item xs={12}>
        <Box
          sx={{
            border: "1px solid #e0e0e0",
            p: 2,
            borderRadius: "8px",
            minHeight: "200px",
            overflowY: "auto",
            fontFamily: "Cardiuma-M",
            boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
            backgroundColor: "#0B1420",
          }}
        >
          <Typography variant="h6" gutterBottom sx={{ color: "white" }}>
            Preview
          </Typography>
          <div
            style={{
              padding: "10px",
            }}
            dangerouslySetInnerHTML={{ __html: value }}
          />
        </Box>
      </Grid>
      {devicePreviews.map((device, index) => (
        <Grid item xs={12} md={6} key={index}>
          <Box
            sx={{
              ...commonStyles,
              width: device.width,
              height: device.height,
              position: "relative",
            }}
            aria-label={device.title}
          >
            <Typography variant="h6" gutterBottom>
              {device.icon} {device.title}
            </Typography>
            <div
              style={{ fontFamily: "'Cardiuma-M'" }}
              dangerouslySetInnerHTML={{
                __html: `
              <style>
                h1, h2, h3, b, strong {
                  font-weight: 900 !important;
                  font-family: 'cardiuma-Bold', sans-serif !important;
                }
                p {
                  font-family: 'cardiuma-regular', sans-serif !important;
                }
                @media (max-width: 600px) {
                  h1 { font-size: 24px !important; }
                  h2 { font-size: 22px !important; }
                  h3 { font-size: 20px !important; }
                }
                @media (min-width: 601px) and (max-width: 900px) {
                  h1 { font-size: 28px !important; }
                  h2 { font-size: 26px !important; }
                  h3 { font-size: 24px !important; }
                }
              </style>
              ${value}`,
              }}
            />
          </Box>
        </Grid>
      ))}
    </Grid>
  );
};

export default DevicePreview;
